import { MouseEvent, useMemo } from 'react';
import { faCalendarDay } from '@fortawesome/pro-light-svg-icons/faCalendarDay';
import Button from '@hotmart/space-lib/dist/components/button';
import clsx from 'clsx';

import { CustomIcon } from 'src/components';
import { useModal } from 'src/hook/useModal';
import i18n from 'src/i18n';
import { useSchedulePostForm } from 'src/hook/useSchedulePostForm';
import { DateUtils } from 'src/utils/date';
import { useUser } from 'src/hook/useUser';

import { SchedulePostModal } from '../SchedulePostModal';
import { ShowSchedulePostModalBtnProps } from './types';

const ShowSchedulePostModalBtn = ({
  isOpen,
  className,
  disabled = false
}: ShowSchedulePostModalBtnProps) => {
  const { locale } = useUser();
  const { openModal, setModalContent } = useModal();
  const { formData } = useSchedulePostForm();

  const [shouldShowScheduleInfo, scheduleInfo] = useMemo(() => {
    let scheduleInfo: string | undefined = undefined;
    const { pubDate, scheduledPubTimeZoneId } = formData;
    const shouldShowScheduleInfo = Boolean(pubDate && scheduledPubTimeZoneId);
    const formattedDateAndTime = DateUtils.formatDateAndTime({
      dateString: pubDate,
      timeZone: scheduledPubTimeZoneId,
      locale
    });

    scheduleInfo = i18n.t(
      'modals.schedule_posts.buttons.schedule_info',
      formattedDateAndTime ?? undefined
    );

    return [shouldShowScheduleInfo, scheduleInfo];
  }, [formData.pubDate, formData.scheduledPubTimeZoneId]);

  if (!isOpen) return null;

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setModalContent(<SchedulePostModal />);
    openModal();
  };

  return (
    <Button
      disabled={disabled}
      variation="default"
      className={clsx('_d-flex _align-items-center _px-4 _py-2 _border-0', className)}
      onClick={handleClick}
    >
      <CustomIcon className="_text-gray-900" icon={faCalendarDay} />
      {shouldShowScheduleInfo ? <span className="_ml-2">{scheduleInfo}</span> : null}
    </Button>
  );
};

export default ShowSchedulePostModalBtn;
